// GameContext.js
import React, { createContext, useEffect, useRef, useState } from "react";
import apiManager from './ApiManager';
import AppConfig from './AppConfig';
import { usePocketlist } from "./comm/global/usePocketlist";
export const GameContext = createContext();

export function GameProvider({ children }) {
    const [userData, set_userData] = useState(null);
    const [rewilding, setRewilding] = useState([]);
    const [rankRewilding, setRankRewilding] = useState([]);
    const [tempEvent, set_tempEvent] = useState(null);
    const [firstLoading, setFirstLoading] = useState(false);
    const [friends, set_friends] = useState([]);
    const [pocketlist, updatePocketlist] = usePocketlist([]);
    const [achievementFriend, set_achievementFriend] = useState(null);

    async function init(_userData) {
        if (_userData)
            set_userData(_userData);
        const rewildingList = await apiManager.fetchGet("rewilding", {}, 0);
        const rankRewilding = await apiManager.fetchGet(`world/ranking-rewilding`, {}, 0);
        rewildingList.forEach(rewilding => {
            if (rewilding.rewilding_place_id !== "" && rewilding.rewilding_photos.length > 0) {
                rewilding.rewilding_photos.forEach(obj => {
                    obj.rewilding_photos_path = `${AppConfig.serverUrl()}rewilding/${rewilding.rewilding_id}/photos/${obj.rewilding_photos_id}`;
                })
            }
        });
        setRewilding(rewildingList);

        const _rankingRewilding = rankRewilding.map(v => {
            const findRewilding = rewildingList.find(r => r.rewilding_id === v.rewilding_id);
            if (findRewilding) {
                findRewilding.rewilding_type_list = v.rewilding_type_list;
                return findRewilding;
            }
        });

        setRankRewilding(_rankingRewilding);
        if (_userData) {
            updateFriends();
            updatePocketlist("init");
        }
        setFirstLoading(true);
    }
  


    const preProcessEvent = (event) => new Promise(async (resolve, reject) => {
        const rewildingObj = rewilding.find(v => v.rewilding_id === event.events_rewilding);
        if (rewildingObj) {
            event.rewildingObj = rewildingObj;
            resolve({
                ...event,
                events_date: new Date(event.events_date),
                events_date_end: new Date(event.events_date_end),
                events_deadline: new Date(event.events_deadline),
                events_created_at: new Date(event.events_created_at),
                events_updated_at: new Date(event.events_updated_at),
                rewildingObj: rewildingObj
            });
        }
        else {
            console.log("========get new rewilding");
            apiManager.fetchGet(`rewilding/${event.events_rewilding}`, {}, 0).then(res => {
                setRewilding(prev=>[...prev,res]);
                event.rewildingObj = res;
                resolve({
                    ...event,
                    events_date: new Date(event.events_date),
                    events_date_end: new Date(event.events_date_end),
                    events_deadline: new Date(event.events_deadline),
                    events_created_at: new Date(event.events_created_at),
                    events_updated_at: new Date(event.events_updated_at),
                    rewildingObj: res
                });
            }).catch(err => {
                resolve(null)
            })
        }
    });

    function updateFriends() {
        apiManager.fetchGet(`user/friends`, {}, 0).then(res => {
            set_friends(res);
        })
    }
   
 



    return (
        <GameContext.Provider value={{
            init, userData, set_userData, rewilding, rankRewilding,
             preProcessEvent, tempEvent, set_tempEvent, firstLoading,
            friends, set_friends, updateFriends, pocketlist, updatePocketlist,
            achievementFriend, set_achievementFriend
        }}>
            {children}
        </GameContext.Provider>
    );
}
